import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { store } from './Redux/store'
import { Provider } from 'react-redux'
import { Buffer } from 'buffer';
window.Buffer = Buffer;

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
